import { useMemo } from 'react';
import { SamplesLanguages } from 'types/enums';

export type PrefixByLocales = { [key in SamplesLanguages]: string };

export const usePrefixByLocales: () => PrefixByLocales = () => {
    const prefixesWithLocale = useMemo(() => {
        return [
            ...Object.values(SamplesLanguages).map((locale) =>
                locale === SamplesLanguages.EN
                    ? [SamplesLanguages.EN, '']
                    : [locale, `/${locale}`],
            ),
        ];
    }, []);

    return Object.fromEntries(prefixesWithLocale);
};
